import { HoverPopover } from '@app/components/base/HoverPopover';
import { PersonLane } from '@app/modules/persons/appearances/types';
import { Box } from '@mui/material';
import { usePersonLaneIdentity } from '../../hooks/usePersonLaneIdentity';
import { PersonLaneAvatar } from '../../shared/PersonLaneAvatar';
import { PersonLaneIdentity } from '../../shared/PersonLaneIdentity';
import { personsCastPopoverProps } from '../../shared/persons-track-popover-props';
import { CAST_AVATAR_PX } from '../../shared/persons-track-visual-tokens';

type PersonCastAvatarProps = {
  lane: PersonLane;
};

/**
 * One person in the summary-strip cast cluster.
 *
 * Shows a small colored avatar (profile image, crop, or initials). Hidden until
 * a display name or "unknown" label is resolved. Hover opens a card with a
 * larger avatar, name, and occupation — no play actions.
 */
export function PersonCastAvatar({ lane }: PersonCastAvatarProps) {
  const { isIdentityReady } = usePersonLaneIdentity(lane);

  if (!isIdentityReady) {
    return null;
  }

  return (
    <HoverPopover
      trigger={
        <Box component="span" sx={{ display: 'inline-flex', lineHeight: 0 }}>
          <PersonLaneAvatar lane={lane} sizePx={CAST_AVATAR_PX} borderWidth={2} dashedWhenUnknown />
        </Box>
      }
      {...personsCastPopoverProps}
    >
      <Box sx={{ p: 1.5 }}>
        <PersonLaneIdentity lane={lane} avatarPx={64} borderWidth={3} dashedWhenUnknown />
      </Box>
    </HoverPopover>
  );
}
